// extracted by mini-css-extract-plugin
export default {"tabBar":"TabbedView__tabBar___thmR0","tab":"TabbedView__tab___ffmnz","tabSelected":"TabbedView__tabSelected___RDkCG"};